import { render, staticRenderFns } from "./AddSandboxBase.vue?vue&type=template&id=6d8b1880&scoped=true"
import script from "./AddSandboxBase.vue?vue&type=script&lang=js"
export * from "./AddSandboxBase.vue?vue&type=script&lang=js"
import style0 from "./AddSandboxBase.vue?vue&type=style&index=0&id=6d8b1880&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8b1880",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d8b1880')) {
      api.createRecord('6d8b1880', component.options)
    } else {
      api.reload('6d8b1880', component.options)
    }
    module.hot.accept("./AddSandboxBase.vue?vue&type=template&id=6d8b1880&scoped=true", function () {
      api.rerender('6d8b1880', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/components/AddSandboxBase.vue"
export default component.exports